(function () {
function init(root) {
  if (root.getAttribute('data-bl-ready')) return;
  root.setAttribute('data-bl-ready', '1');
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-bl-config]').textContent); } catch (e) {}
  var UPLIFT = 1 + (parseFloat(cfg.uplift) || 0) / 100;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function euro(n) { return n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }

  /* ---------- Timeline ---------- */
  var steps = Array.prototype.slice.call(root.querySelectorAll('.bl-step'));
  var active = 0, auto = !reduceMotion, visible = false, timer = null;
  var autoBtn = root.querySelector('[data-autoplay]');
  function setStep(i) {
    active = i;
    steps.forEach(function (s, idx) {
      s.classList.toggle('is-active', idx === i);
      s.classList.toggle('is-done', idx < i);
      var b = s.querySelector('[data-step-btn]');
      if (b) b.setAttribute('aria-current', idx === i ? 'step' : 'false');
    });
  }
  function syncAuto() {
    if (autoBtn) { autoBtn.textContent = auto ? 'Animation pausieren' : 'Animation abspielen'; autoBtn.setAttribute('aria-pressed', auto ? 'true' : 'false'); }
    clearInterval(timer); timer = null;
    if (auto && visible) timer = setInterval(function () { setStep((active + 1) % steps.length); }, 3500);
  }
  steps.forEach(function (s, idx) {
    var b = s.querySelector('[data-step-btn]');
    if (b) b.addEventListener('click', function () { auto = false; setStep(idx); syncAuto(); });
  });
  if (autoBtn) autoBtn.addEventListener('click', function () { auto = !auto; syncAuto(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; syncAuto(); }, { threshold: 0.2 }).observe(root.querySelector('[data-steps]'));
  } else { visible = true; syncAuto(); }
  setStep(0);

  /* ---------- Formular ---------- */
  var form = root.querySelector('#bl-leasing-form');
  if (!form || !root.querySelector('[data-brand]')) return;

  var brandSel = root.querySelector('[data-brand]');
  var modelSel = root.querySelector('[data-model]');
  var status = root.querySelector('[data-bike-status]');
  var optsBox = root.querySelector('[data-bike-opts]');
  var reducedNote = root.querySelector('[data-reduced-note]');
  var soldNote = root.querySelector('[data-soldout-note]');
  var otherBox = root.querySelector('[data-other]');
  var otherToggle = root.querySelector('[data-other-toggle]');
  var otherLink = root.querySelector('[data-other-link]');
  var otherSpec = root.querySelector('[data-other-spec]');
  var lockSel = root.querySelector('[data-lock]');
  var provSel = root.querySelector('[data-provider]');
  var provOther = root.querySelector('[data-provider-other]');
  var provName = root.querySelector('[data-provider-name]');
  var missingBox = root.querySelector('[data-missing]');

  var bikes = [], bike = null, choice = [], useOther = false, brands = {}, brandKeys = [];

  function priceOf(v) { return parseFloat(v.price) || 0; }
  function cmpOf(v) { return parseFloat(v.compare_at_price) || 0; }
  function availVariants(p) { return p.variants.filter(function (v) { return v.available; }); }
  function minVariant(p) {
    var pool = availVariants(p).length ? availVariants(p) : p.variants, best = null;
    pool.forEach(function (v) { if (!best || priceOf(v) < priceOf(best)) best = v; });
    return best;
  }
  function allSame(p) { var f = priceOf(p.variants[0]); return p.variants.every(function (v) { return priceOf(v) === f; }); }
  function vendorKey(p) { return String(p.vendor || 'Sonstige').trim().toLowerCase(); }

  function addBrand(p) {
    var name = String(p.vendor || 'Sonstige').trim();
    var key = name.toLowerCase();
    if (!brands[key]) brands[key] = { name: (name === name.toUpperCase() && name.length > 4) ? name.charAt(0) + name.slice(1).toLowerCase() : name, list: [] };
    else if (brands[key].name === brands[key].name.toUpperCase() && name !== name.toUpperCase()) brands[key].name = name;
    brands[key].list.push(p);
  }
  function renderBrands() {
    brandKeys = Object.keys(brands).sort(function (a, b) { return brands[a].name.localeCompare(brands[b].name, 'de'); });
    brandKeys.forEach(function (k) { brands[k].list.sort(function (a, b) { return a.title.localeCompare(b.title, 'de'); }); });
    brandSel.innerHTML = '';
    addOpt(brandSel, '', 'Bitte Marke wählen');
    brandKeys.forEach(function (k) { addOpt(brandSel, k, brands[k].name + ' (' + brands[k].list.length + ')'); });
  }

  // Alle Räder aus den gewählten Kollektionen laden (öffentlicher Shopify-Endpunkt, 250 pro Seite), Duplikate raus
  var seen = {};
  function loadOne(url, page) {
    return fetch(url + '/products.json?limit=250&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d && d.products) || [];
        ps.forEach(function (p) {
          if (seen[p.handle] || !p.variants || !p.variants.length) return;
          seen[p.handle] = 1; bikes.push(p);
        });
        if (ps.length === 250 && page < 8) return loadOne(url, page + 1);
      })
      .catch(function () {});
  }

  // Einzelnes Rad direkt laden (Rad aus der Produktseite, das in keiner der Kollektionen steckt)
  function loadSingle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        return {
          handle: p.handle, title: p.title, vendor: p.vendor,
          options: (p.options || []).map(function (o) { return { name: o.name, values: o.values }; }),
          variants: p.variants.map(function (v) {
            return {
              id: v.id, available: v.available,
              price: (v.price / 100).toFixed(2),
              compare_at_price: v.compare_at_price ? (v.compare_at_price / 100).toFixed(2) : null,
              option1: v.option1, option2: v.option2, option3: v.option3
            };
          })
        };
      })
      .catch(function () { return null; });
  }

  // Vorbelegung per Link: ?rad=<handle>&variant=<variant-id>#anfrage
  function prefill() {
    var params = new URLSearchParams(location.search);
    var pre = params.get('rad'), preVar = params.get('variant');
    if (!pre) return;
    var hit = bikes.filter(function (p) { return p.handle === pre; })[0];
    var ready = hit ? Promise.resolve(hit) : loadSingle(pre).then(function (p) {
      if (!p) return null;
      seen[p.handle] = 1; bikes.push(p); addBrand(p); renderBrands();
      return p;
    });
    ready.then(function (p) {
      if (!p) return;
      pick(p);
      if (preVar) {
        var v = p.variants.filter(function (x) { return String(x.id) === String(preVar); })[0];
        if (v) {
          choice = p.options.map(function (o, i) { return v['option' + (i + 1)] || ''; });
          renderOpts(); update();
        }
      }
      if (location.hash === '#anfrage') {
        var target = root.querySelector('#anfrage');
        if (target) target.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    });
  }

  var urls = cfg.bikesUrls || [];
  if (!urls.length) { status.textContent = 'Keine Fahrrad-Kollektionen hinterlegt.'; prefill(); }
  else {
    Promise.all(urls.map(function (u) { return loadOne(u, 1); })).then(function () {
      bikes.forEach(addBrand);
      if (!bikes.length) { status.textContent = 'Die Räder konnten nicht geladen werden. Nutze „Rad nicht gefunden? Link einfügen“.'; brandSel.innerHTML = '<option value="">Keine Räder gefunden</option>'; prefill(); return; }
      renderBrands();
      var inStock = bikes.filter(function (p) { return availVariants(p).length; }).length;
      status.textContent = bikes.length + ' Räder von ' + brandKeys.length + ' Marken, davon ' + inStock + ' sofort verfügbar. Nicht vorrätige Größen und Farben sind markiert.';
      prefill();
    });
  }

  function addOpt(sel, val, txt) { var o = document.createElement('option'); o.value = val; o.textContent = txt; sel.appendChild(o); return o; }
  function priceLabel(p) {
    var v = minVariant(p);
    var txt = (p.variants.length > 1 && !allSame(p) ? 'ab ' : '') + euro(priceOf(v));
    if (cmpOf(v) > priceOf(v)) txt += ' statt ' + euro(cmpOf(v));
    if (!availVariants(p).length) txt += ' – derzeit nicht vorrätig';
    return txt;
  }
  function fillModels(key) {
    modelSel.innerHTML = '';
    if (!key || !brands[key]) { addOpt(modelSel, '', 'Erst Marke wählen'); modelSel.disabled = true; return; }
    addOpt(modelSel, '', 'Bitte Modell wählen');
    brands[key].list.forEach(function (p) { addOpt(modelSel, p.handle, p.title + ' · ' + priceLabel(p)); });
    modelSel.disabled = false;
  }

  brandSel.addEventListener('change', function () {
    brandSel.classList.remove('is-invalid');
    bike = null; choice = []; fillModels(brandSel.value); renderOpts(); update();
  });
  modelSel.addEventListener('change', function () {
    modelSel.classList.remove('is-invalid');
    var p = bikes.filter(function (x) { return x.handle === modelSel.value; })[0];
    if (p) pick(p); else { bike = null; choice = []; renderOpts(); update(); }
  });

  function pick(p) {
    bike = p; useOther = false; otherBox.hidden = true;
    var k = vendorKey(p);
    if (brandSel.value !== k) { brandSel.value = k; fillModels(k); }
    modelSel.value = p.handle;
    choice = p.options.map(function (o) { return o.values.length === 1 ? o.values[0] : ''; });
    renderOpts(); update();
  }

  // Ist ein Wert lieferbar – unter Berücksichtigung der übrigen bereits gewählten Optionen?
  function valueInStock(idx, val) {
    return bike.variants.some(function (v) {
      if (!v.available || v['option' + (idx + 1)] !== val) return false;
      return choice.every(function (c, j) { return j === idx || !c || v['option' + (j + 1)] === c; });
    });
  }

  function renderOpts() {
    optsBox.innerHTML = '';
    if (!bike) return;
    bike.options.forEach(function (o, idx) {
      if (o.values.length === 1 && /^default title$/i.test(o.values[0])) return;
      var lab = document.createElement('label');
      lab.appendChild(document.createTextNode(o.name + ' *'));
      var sel = document.createElement('select');
      sel.setAttribute('data-opt', idx);
      addOpt(sel, '', 'Bitte wählen');
      o.values.forEach(function (val) {
        var op = addOpt(sel, val, val + (valueInStock(idx, val) ? '' : ' – nicht vorrätig'));
        if (choice[idx] === val) op.selected = true;
      });
      sel.addEventListener('change', function () { choice[idx] = sel.value; sel.classList.remove('is-invalid'); renderOpts(); update(); });
      lab.appendChild(sel);
      optsBox.appendChild(lab);
    });
  }

  function currentVariant() {
    if (!bike) return null;
    if (choice.some(function (c) { return !c; })) return null;
    return bike.variants.filter(function (v) {
      return choice.every(function (c, i) { return v['option' + (i + 1)] === c; });
    })[0] || null;
  }

  otherToggle.addEventListener('click', function () {
    useOther = otherBox.hidden;
    otherBox.hidden = !useOther;
    if (useOther) { bike = null; choice = []; brandSel.value = ''; fillModels(''); renderOpts(); otherLink.focus(); }
    update();
  });
  [otherLink, otherSpec].forEach(function (el) { el.addEventListener('input', function () { el.classList.remove('is-invalid'); update(); }); });
  provSel.addEventListener('change', function () { provOther.hidden = provSel.value !== 'Anderer'; provSel.classList.remove('is-invalid'); update(); });
  provName.addEventListener('input', update);
  lockSel.addEventListener('change', function () { lockSel.classList.remove('is-invalid'); update(); });
  Array.prototype.forEach.call(form.querySelectorAll('[data-delivery]'), function (r) { r.addEventListener('change', update); });

  function setS(k, v) { var el = root.querySelector('[data-s="' + k + '"]'); if (el) el.textContent = v; }
  function setH(k, v) { var el = form.querySelector('[data-h="' + k + '"]'); if (el) el.value = v; }

  function update() {
    var v = currentVariant();
    var reduced = !!v && cmpOf(v) > priceOf(v);
    var leasePrice = v ? (reduced ? Math.round(priceOf(v) * UPLIFT * 100) / 100 : priceOf(v)) : null;
    reducedNote.hidden = !reduced;
    soldNote.hidden = !(v && !v.available);

    var bikeName = bike ? bike.title : (useOther ? (otherLink.value || '') : '');
    var variantTxt = bike ? choice.filter(Boolean).join(' / ') : (useOther ? otherSpec.value : '');
    setS('bike', bikeName || '–');
    setS('variant', variantTxt || '–');

    var lockOpt = lockSel.options[lockSel.selectedIndex];
    var lockPrice = lockOpt && lockOpt.getAttribute('data-price') ? parseFloat(lockOpt.getAttribute('data-price')) : null;
    setS('lock', lockSel.value ? lockOpt.textContent : '–');

    var prov = provSel.value === 'Anderer' ? (provName.value || 'Anderer') : provSel.value;
    setS('provider', prov || '–');

    var del = form.querySelector('[data-delivery]:checked');
    var delType = del ? del.getAttribute('data-delivery') : '';
    setS('delivery', delType === 'pickup' ? 'Abholung Freiburg' : (delType === 'ship' ? 'Versand' : '–'));
    root.querySelector('[data-s="shiprow"]').hidden = delType !== 'ship';

    setS('bikelabel', v ? (reduced ? 'Rad (' + euro(priceOf(v)) + ' + ' + cfg.uplift + ' %)' : 'Rad (UVP)') : 'Rad');
    setS('bikeprice', v ? euro(leasePrice) : (useOther && otherLink.value ? 'laut Angebot' : '–'));
    setS('lockprice', lockPrice ? euro(lockPrice) : (lockSel.value ? 'laut Angebot' : '–'));
    var shipCost = delType === 'ship' ? (parseFloat(cfg.ship) || 0) : 0;
    var total = (v && lockPrice && delType) ? leasePrice + lockPrice + shipCost : null;
    setS('total', total !== null ? euro(total) : 'folgt im Angebot');

    setH('bike', bikeName);
    setH('variant', variantTxt);
    setH('url', bike ? location.origin + '/products/' + bike.handle + (v ? '?variant=' + v.id : '') : '');
    setH('price', v ? euro(priceOf(v)) + (reduced ? ' (statt ' + euro(cmpOf(v)) + ')' : '') + (v.available ? '' : ' – derzeit nicht vorrätig') : '');
    setH('reduced', v ? (reduced ? 'ja' : 'nein') : '');
    setH('leaseprice', v ? euro(leasePrice) + (reduced ? ' (Aktionspreis + ' + cfg.uplift + ' %)' : ' (UVP)') : '');
    var totalTxt = '';
    if (total !== null) totalTxt = euro(total) + (shipCost ? ' (inkl. ' + euro(shipCost) + ' Versand)' : '');
    else if (v && delType) totalTxt = euro(leasePrice + shipCost) + (shipCost ? ' (inkl. ' + euro(shipCost) + ' Versand)' : '') + ' zzgl. Schloss nach Beratung';
    setH('total', totalTxt);
  }

  function missing() {
    var m = [], bad = [];
    if (useOther) {
      if (!otherLink.value.trim()) { m.push('Link zum Rad'); bad.push(otherLink); }
      if (!otherSpec.value.trim()) { m.push('Größe und Farbe'); bad.push(otherSpec); }
    } else if (!bike) { m.push('Rad'); bad.push(brandSel.value ? modelSel : brandSel); }
    else {
      bike.options.forEach(function (o, i) {
        if (!choice[i]) { m.push(o.name); var s = optsBox.querySelector('[data-opt="' + i + '"]'); if (s) bad.push(s); }
      });
    }
    if (!lockSel.value) { m.push('Schloss'); bad.push(lockSel); }
    if (!provSel.value) { m.push('Leasinganbieter'); bad.push(provSel); }
    else if (provSel.value === 'Anderer' && !provName.value.trim()) { m.push('Name des Leasinganbieters'); bad.push(provName); }
    if (!form.querySelector('[data-delivery]:checked')) m.push('Abholung oder Versand');
    Array.prototype.forEach.call(form.querySelectorAll('[data-req]'), function (el) {
      var val = el.value.trim();
      var ok = val && (el.type !== 'email' || /.+@.+\..+/.test(val)) && (!el.hasAttribute('data-zip') || /^\d{5}$/.test(val));
      if (!ok) { m.push(el.getAttribute('data-req')); bad.push(el); }
    });
    var consent = form.querySelector('[data-consent]');
    if (!consent.checked) m.push('Einverständnis Datenschutz');
    return { list: m, els: bad };
  }

  Array.prototype.forEach.call(form.querySelectorAll('[data-req]'), function (el) { el.addEventListener('input', function () { el.classList.remove('is-invalid'); }); });

  form.addEventListener('submit', function (e) {
    update();
    var r = missing();
    root.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    if (r.list.length) {
      e.preventDefault();
      r.els.forEach(function (el) { el.classList.add('is-invalid'); });
      missingBox.hidden = false;
      missingBox.textContent = 'Bitte noch ergänzen: ' + r.list.join(', ');
      missingBox.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    } else {
      missingBox.hidden = true;
      // Leere Felder nicht mitschicken, damit die Mail übersichtlich bleibt
      Array.prototype.forEach.call(form.querySelectorAll('input[name^="contact["], select[name^="contact["], textarea[name^="contact["]'), function (el) {
        if (el.type === 'radio' || el.type === 'checkbox') return;
        if (!String(el.value || '').trim()) el.disabled = true;
      });
    }
  });

  update();
}
function boot() { Array.prototype.forEach.call(document.querySelectorAll('.bl[data-bl]'), init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
